<template>
  <span ref="select" :class="['noBorder', {'disabled': disabled}]">
    <v-row v-if="label" class="my-0 ellipsis" no-gutters>
      <span class="_subtitleFormFont">{{ label }}:</span>
    </v-row>
    <v-select
      ref="vSelect"
      :class="multiple ? `select-v2 ${className}` : `${className}`"
      dense
      :solo="solo"
      filled
      outlined
      :hide-details="hideDetails"
      flat
      v-model="selectedValue"
      :loading="loading"
      :disabled="disabled"
      :multiple="multiple"
      :chips="chips"
      :return-object="returnObject"
      :item-text="itemText"
      :item-value="itemValue"
      :placeholder="placeholder"
      :items="items"
      :error-messages="errorMessages"
      :background-color="backgroundColor"
      :style="`width: ${width}; height: ${height};`"
      :menu-props="menuProps"
      :no-data-text="noDataText"
      :rules="rules"
      :validate-on-blur="validateOnBlur"
      :readonly="readonly"
      @change="$emit('change', $event)"
      @click="$emit('click', $event)"
      @focus="$emit('focus', $event)"
    >

    <template v-slot:append>
      <v-icon size="12" :color="disabled ? 'grey' : 'bt_text'" :class="iconSelectPosition">fa-solid fa-angle-down</v-icon>
    </template>

    <template v-slot:prepend-inner>
      <v-icon size="12" color="bt_color" :class="!icon ? 'pl-1' : iconPosition">{{ icon }}</v-icon>
    </template>

    <template v-if="useSelectionTemplate" v-slot:selection="{item, index, select, selected, disabled}">
      <slot name="selection"
        :item="item"
        :index="index"
        :select="select"
        :selected="selected"
        :disabled="disabled"
      >
      </slot>
    </template>

    <template v-if="useItemTemplate" v-slot:item="{item, on, attrs}">
      <slot name="item" :item="item" :on="on" :attrs="attrs"></slot>
    </template>

    <template v-if="showSelectAll && multiple" v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="$emit('toggleSelectAll')">
        <v-list-item-action>
          <v-icon>{{iconForSelectAll}}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{selectedValue.length !== items.length ? 'Selecionar tudo' : 'Desmarcar tudo'}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>

    </v-select>
  </span>
</template>

<script>
  export default {
    props: {
      width: {type: String, default: '100%'},
      height: {type: String, default: '40px'},
      backgroundColor: {type: String, default: '#F6F7F7'},
      icon: {type: String},
      className: {type: String, default: 'select-v2'},
      iconSize: {type: String, default: 'small'},
      iconPosition: {type: String, default: 'pr-3 pl-2'},
      iconSelectPosition: {type: String, default: 'mt-2'},
      items: {type: Array, required: true},
      value: { required: true },
      label: {type: String, required: false},
      placeholder: {type: String, required: false},
      itemText: {type: [String, Function], required: false},
      itemValue: {type: String, required: false},
      returnObject: {type: Boolean, default: false},
      fullWidth: {type: Boolean, default: false},
      chips: {type: Boolean, default: false},
      multiple: {type: Boolean, default: false},
      mobile: {type: Boolean, default: false},
      menuProps: {type: [String, Object], default: () => ({ bottom: true, offsetY: true }), required: false},
      rules: {type: Array},
      errorMessages: {type: String},
      validateOnBlur: {type: Boolean, default: false},
      hideDetails: {type: Boolean, default: true},
      solo: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},
      loading: {type: Boolean, default: false},
      noDataText: {type: String, required: false},
      showBorder: {type: Boolean, default: false}, // shows a border
      useSelectionTemplate: {type: Boolean, default: false},
      useItemTemplate: {type: Boolean, default: false},
      showSelectAll: {type: Boolean, default: false},
      readonly: {type: Boolean, default: false}
    },
    computed: {
      selectedValue: {
        get () {
          return this.value
        },
        set (v) {
          return this.$emit('input', v)
        }
      },

      iconForSelectAll () {
        if (this.selectedValue.length === this.items.length) return 'mdi-close-box'
        if (this.selectedValue.length > 0 && this.selectedValue.length < this.items.length) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      }
    },
    mounted () {
      if (this.showBorder) this.$refs.select.classList.remove('noBorder')
    }
  }
</script>

<style scoped>
.v-select {
  border-radius: 8px !important;
}

.v-text-field--outlined /deep/ fieldset {
  border-color: #EDEDF1 !important;
}

.noBorder .v-text-field--outlined /deep/ fieldset {
  border: transparent 1px solid !important;
}

.select-v2 /deep/ .v-select__selection {
  color: #24252D !important;
}

.disabled .select-v2 /deep/ .v-select__selection {
  color: grey !important;
}

.ellipsis {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipsis span {
  overflow: hidden;
  text-overflow: ellipsis;  
}
</style>

<style>
  .select-v2 .v-select__selection--disabled {
    color: black !important;
  }
  .select-v2 .v-input__control {
    height: auto;
    min-height: 40px !important;
  }
  .select-v2 .v-input__control .v-input__slot {
    min-height: 40px !important;
  }
  .select-v2 > .v-input__control > .v-input__slot > .v-input__prepend-inner {
    margin-top: 15px !important;
  }

  .select-v2 {
    font-size: 0.9rem !important;
    font-weight: 400 !important;
  }  
</style>
